import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Dropdown,
  ButtonGroup,
  Card,
  Modal,
  Button,
  Form,
  Breadcrumb,
} from "react-bootstrap";
import Select from "react-select";
import {
  getOrganizations,
  getCourses,
  assignOperation,
} from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import { Link } from "react-router-dom";

const AllOrg = () => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Sl. No.",
      },
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "organizationCoordinator",
        header: "Organization Coordinator",
      },
      {
        accessorKey: "assignCourse",
        header: "Assign Course",
        cell: ({ row }) => (
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleAssignCourseClick(row.original)}
          >
            Assign
          </Button>
        ),
      },
    ],
    []
  );

  const [cookies, setCookies] = useCookies();
  const [organizations, setOrganizations] = useState([]);
  console.log(organizations);

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      try {
        const response = await getOrganizations(cookies.email, cookies.roleId);
        const organizationData = response.data.map((organization, index) => ({
          ...organization,
          id: index + 1,
          organizationCoordinator: organization?.organizationCoordinator?.name,
          organizationCoordinatorEmail:
            organization?.organizationCoordinator?.email,
        }));
        setOrganizations(organizationData);
        const courseResponse = await getCourses(
          cookies.email,
          cookies.roleId,
          cookies.organizationId,
          cookies.department,
          cookies.userId
        );
        const courseList = courseResponse.data.map((course) => ({
          label: course.courseTitle,
          value: course.courseId,
        }));
        setCourses(courseList);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch organizations:", err);
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, [cookies.email, cookies.roleId]);

  const handleAssignCourseClick = (organization) => {
    setSelectedOrg(organization); // Set the selected organization's details
    setShowModal(true); // Show the modal
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedOrg(null); // Clear the selected organization's details
    setSelectedCourses([]); // Reset selected courses
  };

  const handleCourseChange = (selectedOptions) => {
    setSelectedCourses(selectedOptions);
  };

  const handleAssignCourses = async () => {
    const body = {
      orgId: selectedOrg.organizationId,
      name: selectedOrg.name,
      email: selectedOrg.email,
      orgCoordinatorEmail: selectedOrg.organizationCoordinatorEmail,
      phoneNumber: selectedOrg.phoneNumber,
      address: selectedOrg.address,
      url: "/organization",
      field: "Course",
      selectedId: selectedCourses.map((course) => course.value),
    };
    const response = await assignOperation(body);
    handleModalClose();
  };

  return (
    <Fragment>
      <Row>
        <Col lg={12} md={12} sm={12}>
          <div
            style={{
              borderBottom: "1px solid #ddd",
              paddingTop: "8px",
              paddingBottom: "8px",
              marginBottom: "10px",
            }}
            className="d-flex align-items-center justify-content-between"
          >
            <div>
              <h3 className="mb-1 h3 fw-bold">Organization</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="#">Organization</Breadcrumb.Item>
                <Breadcrumb.Item active>All</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            {cookies.roleId === "platformCoordinator" && (
              <div className="ms-auto">
                <Dropdown as={ButtonGroup}>
                  <Dropdown.Toggle
                    variant="primary"
                    id="dropdown-custom-components"
                  >
                    + Add
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/add-new-org/">
                      Add Organization
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/add-org-coordinator/">
                      Add Organization Coordinator
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12} md={12} sm={12}>
          <Card>
            <Card.Body className="p-0">
              <TanstackTable
                data={organizations}
                columns={columns}
                filter={true}
                filterPlaceholder="Search...."
                pagination={true}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal for Assign Course */}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Assign Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrg && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Organization Name</Form.Label>
                <Form.Control type="text" value={selectedOrg.name} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Coordinator Name</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedOrg.organizationCoordinator || "Not Assigned"}
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={selectedOrg.email} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Assign Courses</Form.Label>
                <Select
                  options={courses}
                  isMulti
                  value={selectedCourses}
                  onChange={handleCourseChange}
                  placeholder="Select Courses"
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAssignCourses}>
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default AllOrg;
